/** Per-section collapse state of the project Dashboard. Installateur Taak and
 *  Planning start open (people look there first); the rest start COLLAPSED as a
 *  compact stack of section headers (each carrying its summary); expand what you need. */
export type SectionKey =
  | 'installateur_taak'
  | 'planning'
  | 'collectoren'
  | 'materiaal'
  | 'interventie'
  | 'vordering'
  | 'activiteit'
  | 'offerte';

export const DEFAULT_OPEN: Record<SectionKey, boolean> = {
  installateur_taak: true,
  planning: true,
  collectoren: false,
  materiaal: false,
  interventie: false,
  vordering: false,
  activiteit: false,
  offerte: false,
};

/** Sections rendered cross-fase (outside the per-fase branch) — their #id anchor
 *  exists regardless of the active fase, so a focus request can resolve even on a
 *  project with zero fases. The rest (planning/collectoren/materiaal) only render
 *  once a fase is selected. */
export const FASE_INDEPENDENT_SECTIONS = new Set<SectionKey>([
  'installateur_taak',
  'interventie',
  'vordering',
  'activiteit',
  'offerte',
]);
